import React from "react";
import { useNavigate } from "react-router-dom";
import { ContextLanguage } from "../../../context/Context.Language";
import {
  LAST_TIME_YOU_STILL_CAN_BOOK,
  RETURN_SAME_DAY,
  RETURN_TIME,
  TEXT_AND_GLOSSARY,
  TEXT_AND_THE_STATE,
  TEXT_AN_ORDER_NOW,
  TEXT_COMING_TO_OTHER,
  TEXT_COMMITTED_TO_THE_ENVIRONMENT,
  TEXT_CREATE,
  TEXT_DEDICATED,
  TEXT_DEDICATED_TEAM,
  TEXT_FIXED_PRICE_NO_SURPRIZE,
  TEXT_INSTEAD_OF_WRAPPING,
  TEXT_IS_YOUR_PROFESSIONAL,
  TEXT_IS_YOUR_PROFESSIONAL2,
  TEXT_IS_YOUR_PROFESSIONAL3,
  TEXT_LAUNDRY_SERVICE,
  TEXT_LAUNDRY_SERVICE_BKK,
  TEXT_LAUNDRY_SERVICE_BKK_AND_PTY,
  TEXT_LAUNDRY_SERVICE_PTY,
  TEXT_LISENCE_TITLE,
  TEXT_MY_LAUNDRY,
  TEXT_OUR_TWO_PILLAR,
  TEXT_RECYCLE,
  TEXT_REDUCE,
  TEXT_REUSE,
  TEXT_THAI_SERVICE_GERMAN_INNOVATION,
  TEXT_THANK_YOU_FOR_READING,
  TEXT_THIS_IS_NOT_JUST,
  TEXT_THIS_IS_WHAT_SETS_US,
  TEXT_WANT_TO_KNOW_MORE,
  TEXT_WE,
  TEXT_YES_RIGHT_HERE,
  TIME_STRING_ENG,
  TIME_THAT_STILL_SAME_DAY_SERVICE,
} from "../../../utils/useConstants";
import { useIsMobile } from "../../../utils/useIsMobile";
import {
  STYLE_BODY_2_REGULAR,
  STYLE_BODY_2_REGULAR_TEXT_BASE,
  STYLE_BODY_2_REGULAR_XS,
  STYLE_HEADING_2,
  STYLE_LINK_BLUE,
  STYLE_MAX_WIDTH_DESKTOP,
  STYLE_PADDING_READING,
  STYLE_UNDERLINE_BLUE_24_16,
} from "../../../utils/useStyle";
import { WhiteSpace } from "../../../utils/useFunction";

const CommittedDesktop = () => {
  const { language } = React.useContext(ContextLanguage);
  return (
    <div className=" mt-10 md:mt-13.5">
      <div className={`${STYLE_HEADING_2(language)} text-center`}>
        {TEXT_COMMITTED_TO_THE_ENVIRONMENT[language]}
      </div>
      <div className={STYLE_UNDERLINE_BLUE_24_16}></div>
      <div
        className={` ${STYLE_BODY_2_REGULAR_TEXT_BASE(language)} text-center `}
      >
        {TEXT_WE[language]}
        <span className=" font-semibold ">
          {TEXT_REDUCE[language]}
          {/* {language === "EN" && ", "} */}
          {TEXT_REUSE[language]}
        </span>
        <span className="">{TEXT_AND_GLOSSARY[language]}</span>
        <span className="font-semibold">{TEXT_RECYCLE[language]}</span>

        {TEXT_INSTEAD_OF_WRAPPING[language]}
      </div>
    </div>
  );
};

const FixedPriceDesktop = () => {
  const { language } = React.useContext(ContextLanguage);
  const isMobile = useIsMobile();
  return (
    <div className=" mt-10 md:mt-13.5">
      <div className={`${STYLE_HEADING_2(language)} text-center`}>
        {TEXT_FIXED_PRICE_NO_SURPRIZE[language]}
      </div>
      <div className={STYLE_UNDERLINE_BLUE_24_16}></div>
      <div
        className={` ${STYLE_BODY_2_REGULAR_TEXT_BASE(
          language
        )} text-center text-laundry-gray-100 `}
      >
        <div className=" font-semibold">{TEXT_THIS_IS_NOT_JUST[language]}</div>
        <span>{TEXT_THIS_IS_WHAT_SETS_US[language]}</span>
        <span> {TEXT_THANK_YOU_FOR_READING[language]}</span>
      </div>
    </div>
  );
};

const HeadDescription = () => {
  const { language } = React.useContext(ContextLanguage);
  const isMobile = useIsMobile();
  return (
    <div className="  mt-6.5 md:mt-[43px] ">
      <div className={`${STYLE_HEADING_2(language)} text-center`}>
        {TEXT_LAUNDRY_SERVICE_BKK_AND_PTY[language]}
      </div>
      <div className={STYLE_UNDERLINE_BLUE_24_16}></div>
      <div
        className={` ${STYLE_BODY_2_REGULAR_TEXT_BASE(language)} text-center `}
      >
        {" "}
        <div>
          {/* <div>{TEXT_THAI_SERVICE_GERMAN_INNOVATION[language]}</div> */}
          <div>
            {language === "TH" ? (
              <span>
                บริการด้วยรอยยิ้มแบบไทย นวัตกรรมใหม่แบบ
                <WhiteSpace>เยอรมัน</WhiteSpace>
                เริ่มต้นจากกรุงเทพ
              </span>
            ) : (
              <span>Thai service. German innovation. Founded in Bangkok.</span>
            )}
          </div>
          <div>{TEXT_COMING_TO_OTHER[language]}</div>
        </div>
      </div>
    </div>
  );
};

const Dedicated = () => {
  const { language } = React.useContext(ContextLanguage);

  return (
    <div className=" mt-10 ">
      <div className={`${STYLE_HEADING_2(language)} text-center`}>
        {TEXT_DEDICATED[language]}
      </div>
      <div className={STYLE_UNDERLINE_BLUE_24_16}></div>
      <div
        className={` ${STYLE_BODY_2_REGULAR_TEXT_BASE(language)} text-center `}
      >
        <span> {TEXT_OUR_TWO_PILLAR[language]}</span>{" "}
        <span className=" font-semibold ">
          {" "}
          {TEXT_DEDICATED_TEAM[language]}{" "}
        </span>{" "}
        <span>{TEXT_AND_THE_STATE[language]}</span>
      </div>
      <div className="flex justify-center items-center gap-2 font-semibold mt-2 md:mt-6 md:h-12">
        <div
          className={` ${
            language === "TH" ? " text-sm-th " : " text-sm "
          } text-laundry-gray-200 font-semibold`}
        >
          {TEXT_LISENCE_TITLE[language]}
        </div>
        <img
          src="/images/boschlogoblack.png"
          className=" h-[25px] md:h-[40px]"
        />
      </div>
    </div>
  );
};

export const WantToKnowMore = () => {
  const { language } = React.useContext(ContextLanguage);
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  return (
    <div className={` mt-10 md:mt-13.5 ${STYLE_MAX_WIDTH_DESKTOP}`}>
      <div className={`${STYLE_HEADING_2(language)} text-center`}>
        {isMobile ? (
          <React.Fragment>
            {language === "TH" ? (
              "คุณรู้จักร้านซักผ้าใกล้ฉันไหม"
            ) : (
              <div>
                <div>Do you have a laundry</div>
                <div>service near me?</div>
              </div>
            )}
          </React.Fragment>
        ) : (
          <React.Fragment>{TEXT_WANT_TO_KNOW_MORE[language]}</React.Fragment>
        )}
      </div>
      <div className={STYLE_UNDERLINE_BLUE_24_16}></div>
      <div
        className={`${STYLE_BODY_2_REGULAR(
          language
        )} px-4 md:px-9 xl:px-[250px] text-center`}
      >
        {language === "TH" ? "ใช่" : "Yes,"}
        <span className=" font-semibold mx-1">{TEXT_MY_LAUNDRY[language]}</span>
        {/* <span>{TEXT_IS_YOUR_PROFESSIONAL[language]}</span>
        <div> {TEXT_IS_YOUR_PROFESSIONAL2[language]}</div> */}
        {language === "TH" && (
          <span>
            คือร้านซักผ้าและทำความสะอาดรองเท้าที่ให้บริการในกรุงเทพ
            เรารับประกันว่าทุกออเดอร์ที่สั่งภายใน {LAST_TIME_YOU_STILL_CAN_BOOK}
            :00 น. เราจะไปรับในวันเดียวกันและส่งคืนภายใน {RETURN_TIME}:00 น.
            ของวันถัดไป สะดวกและรวดเร็ว! เร็วกว่านี้ได้ไหม? เฉพาะในกรุงเทพฯ
            แค่เลือกบริการส่งคืนด่วนในวันเดียวกันก่อน{" "}
            {TIME_THAT_STILL_SAME_DAY_SERVICE}:00 น. เราจะไปรับและส่งคืน
            ออเดอร์ภายใน {RETURN_SAME_DAY}:00 น. ของวันเดียวกัน
            <div>
              <span
                className={STYLE_LINK_BLUE}
                onClick={() => {
                  navigate("/OurServices");
                }}
              >
                {TEXT_CREATE[language]}
              </span>
              <span>{TEXT_AN_ORDER_NOW[language]}</span>
            </div>
          </span>
        )}
        {language === "EN" && (
          <span>
            is your professional laundry service and shoe cleaning service in
            Bangkok. We guarantee: All orders placed by{" "}
            {LAST_TIME_YOU_STILL_CAN_BOOK}:00 will be picked up on the same day
            and returned by {RETURN_SAME_DAY}:00 the next day - fast & easy! You
            want it faster? In Bangkok only - Activate our Same Day Express
            Service before {TIME_THAT_STILL_SAME_DAY_SERVICE}:00{" "}
            {TIME_STRING_ENG}, and your items will be picked up and returned by{" "}
            {RETURN_SAME_DAY}:00 on the same day.
            {isMobile && <br />}
            <span
              className={STYLE_LINK_BLUE}
              onClick={() => {
                navigate("/OurServices");
              }}
            >
              {TEXT_CREATE[language]}
            </span>
            <span>{TEXT_AN_ORDER_NOW[language]}</span>
          </span>
        )}
        <div>
          {/* {TEXT_MY_LAUNDRY_BACK_SAME_DAY[language]} */}
          {/* {isMobile ? (
            <React.Fragment>
              {language === "TH" ? (
                <div>
                  <span
                    className={STYLE_LINK_BLUE}
                    onClick={() => {
                      navigate("/OurServices");
                    }}
                  >
                    {TEXT_CREATE[language]}
                  </span>
                  <span>{TEXT_AN_ORDER_NOW[language]}</span>
                </div>
              ) : (
                <span>
                  <span
                    className={STYLE_LINK_BLUE}
                    onClick={() => {
                      navigate("/OurServices");
                    }}
                  >
                    {TEXT_CREATE[language]}
                  </span>
                  <span>{TEXT_AN_ORDER_NOW[language]}</span>{" "}
                </span>
              )}
            </React.Fragment>
          ) : (
            <React.Fragment>
              <span
                className={STYLE_LINK_BLUE}
                onClick={() => {
                  navigate("/OurServices");
                }}
              >
                {TEXT_CREATE[language]}
              </span>
              <span>{TEXT_AN_ORDER_NOW[language]}</span>{" "}
            </React.Fragment>
          )} */}
        </div>

        {isMobile ? (
          <div>
            <div
              onClick={() => {
                navigate("/Bangkok");
              }}
              className={STYLE_LINK_BLUE + " cursor-pointer"}
            >
              {TEXT_LAUNDRY_SERVICE_BKK[language]}
            </div>
            {/* <div
              onClick={() => {
                navigate("/Pattaya");
              }}
              className={STYLE_LINK_BLUE + " cursor-pointer"}
            >
              {TEXT_LAUNDRY_SERVICE_PTY[language]}
            </div> */}
          </div>
        ) : (
          <div>
            <span
              onClick={() => {
                navigate("/Bangkok");
              }}
              className={STYLE_LINK_BLUE + " cursor-pointer"}
            >
              {TEXT_LAUNDRY_SERVICE_BKK[language]}
            </span>
            {/* <span
              onClick={() => {
                navigate("/Pattaya");
              }}
              className={STYLE_LINK_BLUE + " cursor-pointer"}
            >
              {TEXT_LAUNDRY_SERVICE_PTY[language]}
            </span> */}
          </div>
        )}

        {/* <div>
          <span
            onClick={() => {
              navigate("/Bangkok");
            }}
            className={STYLE_LINK_BLUE + " cursor-pointer"}
          >
            {TEXT_LAUNDRY_SERVICE_BKK[language]}
          </span>
          <span
            onClick={() => {
              navigate("/Pattaya");
            }}
            className={STYLE_LINK_BLUE + " cursor-pointer"}
          >
            {TEXT_LAUNDRY_SERVICE_PTY[language]}
          </span>
        </div> */}
      </div>
    </div>
  );
};

const AboutList = () => {
  const isMobile = useIsMobile();
  return (
    <React.Fragment>
      <div
        className={`${STYLE_PADDING_READING} ${STYLE_MAX_WIDTH_DESKTOP} px-4`}
      >
        {/* <img src="/images/logo.png" className={`${STYLE_IMG_CENTER} mb-6`} /> */}
        <HeadDescription />
        <CommittedDesktop />
        <Dedicated />
        <FixedPriceDesktop />
      </div>

      {/* <WantToKnowMore /> */}
    </React.Fragment>
  );
};
export default AboutList;
